import React, { useState } from "react";
import { discountGroupObjects, store_availability_fields } from "../data";
import { Box } from "@mui/material";
import { arrType } from "data/globalData";
import RenderInputField from "components/MboPaymentWorking/CommonComponents/RenderInputFiled/RenderInputFiled";
import { GlobalState } from "context/GlobalContext";


export const getUniqueFieldData = (data = [], field) => {
	return [...new Set(data?.map((item) => item[field]))]
		.filter(Boolean)
		.map((value) => ({
			name: value,
			key: value,
		}));
};

function StoreAvailabilitySection({ value, setValue, disable, data }) {

	const [filterColumns, setFilterColumns] = useState(store_availability_fields);
	const { setSnackBar, snackBar, setLoadingOpen } = GlobalState();

	const isChannelMBO = value?.[discountGroupObjects.brand_channel.key]?.channel === "MBO"

	let filteredData = data
	let zoneData = []
	let stateData = []
	let cityData = []
	let storeGradeData = []
	let storeData = []

	if (isChannelMBO && value?.[discountGroupObjects.store_availability.key]?.distributor?.length) {
		zoneData = filteredData.filter((item) => value?.[discountGroupObjects.store_availability.key]?.distributor.includes(item?.distributor));
	}else{
		zoneData = filteredData
	}
	if (value?.[discountGroupObjects.store_availability.key]?.zone?.length) {
		stateData = zoneData.filter((item) => value?.[discountGroupObjects.store_availability.key]?.zone.includes(item?.zone));
	}
	if (value?.[discountGroupObjects.store_availability.key]?.state?.length) {
		cityData = stateData.filter((item) => value?.[discountGroupObjects.store_availability.key]?.state.includes(item?.state));
	}
	if (value?.[discountGroupObjects.store_availability.key]?.city?.length) {
		storeGradeData = cityData.filter((item) => value?.[discountGroupObjects.store_availability.key]?.city.includes(item?.city));
	}
	if (value?.[discountGroupObjects.store_availability.key]?.store_grade?.length) {
		storeData = storeGradeData.filter((item) => value?.[discountGroupObjects.store_availability.key]?.store_grade.includes(item?.store_grade));
	}

	return (
		<Box pl={2} width="90%">
			<Box display="flex" columnGap={"2%"} rowGap="10px" flexWrap="wrap">
				{store_availability_fields?.map((row) => {
					const column = {
						...row,
						constraints: {
							...row.constraints,
							DISPLAY: row?.key === "distributor" ? isChannelMBO : true,
						},
					};
					let option_data = row.option_data ? row.option_data : {};

					if (row?.key === "distributor") {
						option_data = {
							type: arrType,
							list: getUniqueFieldData(data, "distributor"),
						};
					}
					if (row?.key === "zone") {
						option_data = {
							type: arrType,
							list: getUniqueFieldData(zoneData, "zone"),
						};
					}
					if (row?.key === "state") {
						option_data = {
							type: arrType,
							list: getUniqueFieldData(stateData, "state"),
						};
					}
					if (row?.key === "city") {
						option_data = {
							type: arrType,
							list: getUniqueFieldData(cityData, "city"),
						};
					}
					if (row?.key === "store_grade") {
						option_data = {
							type: arrType,
							list: getUniqueFieldData(storeGradeData, "store_grade"),
						};
					}
					if (row?.key === "store") {
						option_data = {
							type: arrType,
							list: getUniqueFieldData(storeData, "store_name"),
						};
					}
					return (
						<RenderInputField
							column={{ ...column, option_data }}
							data={value}
							setData={setValue}
							width="49%"
							selectOptObjName={"option_data"}
							key={column.key}
							disabled={disable}
						/>
					);
				})}
			</Box>
		</Box>
	);
}

export default StoreAvailabilitySection;
